import React from "react";

/**
 * Custom Loader component with full and compact modes
 *
 * @param {string} color - Tailwind text color for spinner (default: text-white)
 * @param {string} message - Optional loading message (default: "Loading...")
 * @param {boolean} compact - Whether to use compact loader (e.g., inside a button)
 */
const Loader = ({
  color = "text-blue-600 dark:text-acs-dark-text",
  message = "Loading...",
  compact = false,
}) => {
  return compact ? (
    <div className="flex items-center gap-fluid-1 animate-pulse transition-none">
      <div
        className={`animate-spin rounded-full h-4 w-4 border-2 border-solid ${color} border-t-transparent`}
      />
      <span className="text-fluid-sm text-gray-800 dark:text-acs-dark-text transition-none">
        {message}
      </span>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center gap-fluid-2 min-h-[200px] transition-none">
      <div
        className={`animate-spin rounded-full h-12 w-12 border-4 border-solid ${color} border-t-transparent`}
      />
      <span className="text-fluid-base animate-bounce text-gray-800 dark:text-acs-dark-text transition-none">
        {message}
      </span>
    </div>
  );
};

export default Loader;
